// ============================================================================
//  Configuración del formulario NAUFest Uruguay 2026 (FormAssembly 5231632).
//
//  Una "persona" (individual, docente o estudiante) se envía como un POST
//  independiente al mismo form de FA. mapPersonaToFA() traduce el objeto
//  interno a los campos tfa_* que espera FormAssembly.
// ============================================================================
import NAU_LOCALIDADES from "./nauLocalidades";

export const FORM_ID = "5231632";

// Fecha de corte de edad (del formulario original): quien nació el 16/09/2008
// o después es menor y NO participa de networking.
export const FECHA_CORTE = "2008-09-16";

// Valores de opción del formulario de FA.
export const ROL = { alumno: "tfa_4674", profesor: "tfa_4675" };
export const GENERO = { Masculino: "tfa_1966", Femenino: "tfa_1967", "No binario": "tfa_1968" };
export const NETWORKING = { Si: "tfa_4670", No: "tfa_4671" };
export const AUTORIZACION = { Si: "tfa_4680", No: "tfa_4681" };

export const GENERO_OPCIONES = ["Masculino", "Femenino", "No binario"];

export const OCUPACION_OPCIONES = [
  "Secundaria", "Bachillerato", "Universidad", "Formación técnica",
  "Trabajo", "Trabajo y estudio", "Otro",
];

// Temas de la mesa de Networking (no existen aún en el FA; se mandan igual).
export const NET_TEMAS = [
  { val: "Primer trabajo", label: "Cómo conseguir tu primer trabajo" },
  { val: "Elegir carrera", label: "Qué estudiar y cómo elegir carrera" },
  { val: "LinkedIn", label: "LinkedIn y marca personal: crecimiento profesional" },
  { val: "IA", label: "IA: cómo usarla a tu favor" },
  { val: "Marketing", label: "Marketing y comunicación" },
  { val: "Emprendimiento", label: "Emprendimiento y proyectos propios" },
  { val: "Camino profesional", label: "Encontrar tu camino profesional" },
  { val: "Vida personal", label: "Trabajo y vida personal" },
  { val: "Finanzas", label: "Finanzas para la vida real" },
];

export const COMO_SE_ENTERO_OPCIONES = [
  "Centro educativo", "Redes sociales", "Sitio web", "Amigo/a",
  "Docente", "Empresa participante", "Otro",
];

export { NAU_LOCALIDADES };

// ¿Es menor de edad para el evento? (nacido en la fecha de corte o después)
export function esMenor(fechaNac) {
  return !!fechaNac && fechaNac >= FECHA_CORTE;
}

// Dado un departamento (label) y localidad (label), devuelve los campos FA.
// El departamento va a tfa_1998; la localidad va al campo dependiente del depto.
function camposUbicacion(departamentoLabel, localidadLabel) {
  const out = {};
  const dep = NAU_LOCALIDADES.departamentos.find((d) => d.label === departamentoLabel);
  if (!dep) return out;
  out[NAU_LOCALIDADES.depField] = dep.val; // tfa_1998
  const loc = dep.localidades.find((l) => l.label === localidadLabel);
  if (loc) out[dep.locField] = loc.val;
  return out;
}

// Traduce una persona interna al FormData de FormAssembly.
//   persona = {
//     rol: "profesor" | "alumno",
//     nombre, apellido, cedula, email, fechaNac,
//     genero: "Masculino"|..., departamento, localidad,
//     centroEducativo,           // texto libre -> tfa_4667
//     networking: "Si"|"No", autorizacion: "Si"|"No",
//     // extras que hoy el FA no tiene pero mandamos igual:
//     ocupacion, net1, net2, net3, comoSeEntero, recibirInfo, institucionEducativa,
//   }
export function mapPersonaToFA(persona) {
  const fa = {};
  fa.tfa_1877 = persona.nombre || "";
  fa.tfa_1875 = persona.apellido || "";
  fa.tfa_4673 = ROL[persona.rol] || ROL.alumno;
  fa.tfa_1 = persona.cedula || "";
  if (persona.genero && GENERO[persona.genero]) fa.tfa_1879 = GENERO[persona.genero];
  fa.tfa_1881 = persona.fechaNac || "";
  fa.tfa_3 = persona.email || "";
  // ID/centro educativo: en grupal viene de centroEducativo (lo carga el
  // docente); en individual, de la institución educativa de la persona.
  fa.tfa_4667 = persona.centroEducativo || persona.institucionEducativa || "";

  Object.assign(fa, camposUbicacion(persona.departamento, persona.localidad));

  // Networking y autorización son obligatorios en FA: siempre mandan un valor.
  // Si no se selecciona, va "No".
  const net = esMenor(persona.fechaNac) ? "No" : (persona.networking || "No");
  fa.tfa_4669 = NETWORKING[net] || NETWORKING.No;

  const autoriz = persona.autorizacion || "No";
  fa.tfa_4679 = AUTORIZACION[autoriz] || AUTORIZACION.No;

  // Campo networking: temas de interés (texto libre en FA).
  // Solo se mandan si es mayor y eligió participar.
  if (!esMenor(persona.fechaNac) && net === "Si") {
    if (persona.net1) fa.tfa_4685 = temaLabel(persona.net1);
    if (persona.net2) fa.tfa_4687 = temaLabel(persona.net2);
    if (persona.net3) fa.tfa_4689 = temaLabel(persona.net3);
  }

  // ¿Cómo te enteraste de NAUFest? (texto libre, requerido en FA).
  fa.tfa_4691 = persona.comoSeEntero || "No especifica";

  // --- Campos que aún no tienen destino en el FA (se mandan para uso futuro) ---
  if (persona.ocupacion) fa.ocupacion = persona.ocupacion;
  if (persona.recibirInfo) fa.recibirInfo = persona.recibirInfo;

  return fa;
}

// Devuelve la etiqueta legible de un tema de networking (o el valor tal cual).
function temaLabel(val) {
  return NET_TEMAS.find((t) => t.val === val)?.label || val;
}